import Parse from 'parse';

export const saveSalesOrderForWH = (data) => {
  return Parse.Cloud.run('saveSalesOrdersForWH', { data });
};

export const getPendingWMSReport = (data) => {
  return Parse.Cloud.run('getPendingWMSReport', data);
};
